import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class UserStateService {
	private accountId: string;
	constructor(private http: HttpClient) { }

	public setAccountId(accountId: string) {
		this.accountId = accountId;
	}

	public getAccountId(): string {
		return this.accountId;
	}
}